module.exports = __webpack_public_path__ + "static/media/lamp.e9f5335c.svg";